export class AiEventsUtils {

  public static resize(list: string, textInput: string, button: string, file: string): void {
    let textarea = document.getElementById(textInput);
    let sendButton = document.getElementById(button);
    if (textarea.scrollHeight < 400) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 2 + 'px';
      sendButton.style.height = textarea.scrollHeight + 2 + 'px';
      this.resizeMediaList(textarea.scrollHeight + 25, list, file);
      this.scrollDown(list);
    }
  }

  private static resizeMediaList(textareaHeight: number, list: string, file: string): void {
    let mediaList = document.getElementById(list);
    let eventsHeaderHeight = document.getElementsByClassName('events__header').item(0).scrollHeight;
    let uploadedFile = document.getElementById(file);
    let uploadedFileHeight = uploadedFile != null ? uploadedFile.scrollHeight : 0;
    setTimeout(() => {
      mediaList.style.height =
        window.innerHeight
        - textareaHeight
        - eventsHeaderHeight
        - uploadedFileHeight
        - 43
        + 'px';
    }, 0);
  }

  public static scrollDown(list: string): void {
    setTimeout(() => {
      let element = document.getElementById(list);
      element.scrollTop = element.scrollHeight;
    }, 300);
  }
}
